import { Row, Col, Form, Input, Space } from "antd";

import { AttachFile, DatePicker } from "../../../../../../../components";
import { AiOutlineCloudUpload } from "react-icons/ai";

const { RangePicker } = DatePicker;

export const SickLetterForm = () => {
  const form = Form.useFormInstance();

  const onCalendarChange = (dates: any) => {
    if (dates && dates[1]) {
      const endDate = dates[1];
      const eExpectedReturnDate = endDate.clone().add(1, "day").endOf("day");
      form.setFieldValue("eExpectedReturnDate", eExpectedReturnDate);
    }
  };

  return (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item name="eFileContent">
          <AttachFile>
            <Space style={{ fontSize: 15 }}>
              Chứng từ đính kèm
              <AiOutlineCloudUpload size={24} />
              (word, excel, pdf, jpg,...)
            </Space>
          </AttachFile>
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian xin nghỉ phép"
          name="eVacationPeriod"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trường này!",
            },
          ]}
        >
          <RangePicker
            className="min-w-full"
            onCalendarChange={onCalendarChange}
          />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian (dự kiến) trở lại làm việc"
          name="eExpectedReturnDate"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trường này!",
            },
          ]}
        >
          <DatePicker className="min-w-full" />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          label="Lý do"
          name="eReason"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập trường này!",
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>
      </Col>
    </Row>
  );
};
